export default __webpack_public_path__ + "static/sms-2cd454ec1ee3924e5dece7e48e7d4dac.png";